import React from 'react';
import cn from 'classnames';
import { animated } from 'react-spring';

import styles from './style.css';

const Project = ({
  style,
  background,
  logo: { png, webp, fallback },
  name,
  description,
  links: { appleStore, googlePlay },
  className
}) => (
  <animated.article style={style} className={cn(styles.project, className)}>
    <div className={styles.project__inner}>
      <picture>
        <source type="image/webp" srcSet={webp} />
        <source srcSet={png} />
        <img className={styles.project__logo} alt={name} src={fallback} />
      </picture>
      <div className={styles.project__container} style={{ background }}>
        <div className={styles.project__header}>
          <h1 className={styles.project__name}>{name}</h1>
          {appleStore && (
            <a
              className={cn(
                styles.project__install,
                styles.project__install__ios
              )}
              target="_blank"
              rel="noopener noreferrer"
              href={appleStore}
            >
              Install
            </a>
          )}
          {googlePlay && (
            <a
              className={cn(
                styles.project__install,
                styles.project__install__android
              )}
              target="_blank"
              rel="noopener noreferrer"
              href={googlePlay}
            >
              Install
            </a>
          )}
        </div>

        <p className={styles.project__description}>{description}</p>
        <div className={styles.project__links}>
          {appleStore && (
            <a target="_blank" rel="noopener noreferrer" href={appleStore}>
              App Store
            </a>
          )}
          {googlePlay && (
            <a target="_blank" rel="noopener noreferrer" href={googlePlay}>
              Google Play
            </a>
          )}
        </div>
      </div>
    </div>
  </animated.article>
);

export default Project;
